export function shouldBlockForClubConfigError({ configError, config } = {}) {
  return Boolean(configError && !config)
}
